import * as React from 'react';
import styles from './MostVisited.module.scss';
import Typography from '@/components/UI/typography/Typography';
import Box from '@/components/UI/box/Box';
import MostVisitedCarousel from '@/components/home/mostVisited/mostVisitedCarousel/MostVisitedCarousel';
const MostVisited = () => {
  return <Box component={'section'} className={styles['most-visited']} data-sentry-element="Box" data-sentry-component="MostVisited" data-sentry-source-file="MostVisited.tsx">
      <Box component={'header'} className={styles['most-visited-header']} data-sentry-element="Box" data-sentry-source-file="MostVisited.tsx">
        <Typography variant="bodyL_Bold" component={'h2'} data-sentry-element="Typography" data-sentry-source-file="MostVisited.tsx">
          مقاصد پربازدید
        </Typography>
      </Box>
      <MostVisitedCarousel data-sentry-element="MostVisitedCarousel" data-sentry-source-file="MostVisited.tsx" />
    </Box>;
};
export default MostVisited;